import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

function Subtitle(props) {
  return (
    <Typography
      align={props.align || 'left'}
      color="primary"
      component="h6"
      gutterBottom={false}
      variant="button"
    >
      {props.children}
    </Typography>
  );
}

Subtitle.propTypes = {
  children: PropTypes.node,
};

export default Subtitle;
